export const zdfFontFamilies: Record<string, string> = {
    fontFamilySansRegular: 'ZdfRegular, Helvetica, Roboto, sans-serif',
    fontFamilySansMedium: 'ZdfMedium, Helvetica, Roboto, sans-serif',
    fontFamilySansSemiBold: ' ZdfSemiBold, Helvetica, Roboto, sans-serif',
    fontFamilyMonoRegular: 'ZdfRegular, Helvetica, Roboto, sans-serif',
    fontFamilyMonoMedium: 'ZdfMedium, Helvetica, Roboto, sans-serif',
    fontFamilyMonoSemiBold: 'ZdfSemiBold, Helvetica, Roboto, sans-serif',
}